var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"property-details-favorite-action"},[_c('b-button',{staticClass:"btn-favorite",attrs:{"variant":"secondary","size":"lg","block":"","disabled":_vm.favoriteIsLoading},on:{"click":_vm.handleFavClick}},[_c('i',{staticClass:"fa-heart",class:[
                    _vm.isFavorite ? 'fas' : 'far',
                    _vm.favoriteIsLoading ? 'pointer-events-none' : '',
                    _vm.isLargeButton ? 'mr-4 large' : ''
                ]}),_vm._v("\n        "+_vm._s(_vm.isFavorite ? 'Favorited' : 'Favorite')+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }